import { useMemo, useEffect } from 'react';
import { DropTargetImpl } from './d3f2928e01b9ca59ca0fc0c4c516e6ca7b11b1cee6df08cf088dbc4d80c3beb8.cfe-internal.js';

function useDropTarget(spec, monitor) {
  var dropTarget = useMemo(function () {
    return new DropTargetImpl(spec, monitor);
  }, [monitor]);
  useEffect(function () {
    dropTarget.spec = spec;
  }, [spec]);
  return dropTarget;
}

export { useDropTarget };
